var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSolar = function SvgSolar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 106 106",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.517 0H60.31v12.793H47.517zm0 93.207H60.31V106H47.517zM0 47.517h12.793V60.31H0zm93.207 0H106V60.31H93.207zm-82.241 38.38 9.137-9.138 9.138 9.138-9.138 9.137zm65.793-65.794 9.138-9.137 9.137 9.137-9.137 9.138zm0 65.794 9.138-9.138 9.137 9.138-9.137 9.137zM10.966 20.103l9.137-9.137 9.138 9.137-9.138 9.138zm69.448 33.81c0 14.638-11.863 26.5-26.5 26.5s-26.5-11.862-26.5-26.5 11.862-26.5 26.5-26.5 26.5 11.863 26.5 26.5z"
  })));
};

export default SvgSolar;